import React, { useState, useEffect } from "react";
import "../styles/vehiclefilters.css";
import { searchVehicleByChassis } from "../services/vehicleSearchService";

function VehicleFilters({ filter, setFilter, fromDate, setFromDate, toDate, setToDate,onSearch }) {

  const [localFromDate, setLocalFromDate] = useState("");
  const [localToDate, setLocalToDate] = useState("");
  const [chassisNo, setChassisNo] = useState("");


  const handleSearch = () => {
  if (!chassisNo.trim()) return;

  onSearch(chassisNo);
};

  useEffect(() => {
  const today = new Date();

  const to = today.toISOString().split("T")[0];

  const firstDayLastMonth = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1
  );

  const from = firstDayLastMonth.toISOString().split("T")[0];

  setToDate(to);
  setFromDate(from);
}, []);

  const filters = [
    { key: "active", label: "In Progress" },
    { key: "all", label: "All" },
    { key: "completed", label: "Shipped" },
    { key: "search", label: "Search" }
  ];

  const showDateRange = filter === "all" || filter === "completed";
  const showSearchBox = filter === "search";

  return (

    <div className="vehicle-filters">

      {/* FILTER BUTTONS */}
      <div className="filter-buttons">
        {filters.map((f) => (
          <button
            key={f.key}
            className={`filter-btn ${filter === f.key ? "active" : ""}`}
            onClick={() => setFilter(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* DATE RANGE (ONLY FOR ALL & COMPLETED) */}
{showDateRange && (
  <div className="date-filter">
    <div>
      <label>From</label>
      <input
        type="date"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
      />
    </div>

    <div>
      <label>To</label>
      <input
        type="date"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
      />
    </div>
  </div>
)}

{/* SEARCH SECTION */}
{showSearchBox && (
  <div className="search-filter">
    <input
      type="text"
      placeholder="Enter Chassis Number"
      value={chassisNo}
      onChange={(e) => setChassisNo(e.target.value)}
      className="search-input"
    />

    <button
  className="search-btn"
  onClick={handleSearch}
>
  Search
</button>
  </div>
)}

    </div>
  );
}

export default VehicleFilters;